module.exports = __webpack_public_path__ + "img/TOP3.4ca03d12.png";